import type { ReactNode } from "react";

import styles from "./SectionHeader.module.css";

interface Props {
  title: string;
  action?: ReactNode;
  as?: "h2" | "h3";
}

export function SectionHeader({ title, action, as: Tag = "h2" }: Props) {
  return (
    <div className={styles.header}>
      <Tag className={styles.title}>{title}</Tag>

      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}